"use strict";

exports.__esModule = true;
exports.signedExtensions = void 0;
const signedExtensions = {
  SetEvmOrigin: {
    extrinsic: {},
    payload: {}
  }
};
exports.signedExtensions = signedExtensions;